import { useEffect, useState } from 'react';

import { IssueStatus } from '@gearbelt/global';
import { Button } from '@gearbelt/ui/components';

import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Select } from '@/components/ui/select';
import { ISSUE_STATUS_OPTIONS } from '@/utils/issue';

function UpdateIssuesStatusDialog({
  open,
  onOpenChange,
  callback,
  loading,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  callback: (value: IssueStatus) => void;
  loading: boolean;
}) {
  const [value, setValue] = useState<{ label: string; value: IssueStatus } | null>(null);

  useEffect(() => {
    if (!open) setValue(null);
  }, [open]);

  function handleSubmit() {
    if (!value) return;
    callback(value.value);
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-11/12 rounded-md sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>Edit Issue Status</DialogTitle>
          <DialogDescription className="text-secondary-text text-left">Bulk editing will change the status of all the issues you selected.</DialogDescription>
        </DialogHeader>

        <Select<{ label: string; value: IssueStatus }> onChange={setValue} name="Issue Status" options={ISSUE_STATUS_OPTIONS} className="w-full" />

        <DialogFooter>
          <Button type="submit" variant="success" disabled={loading || !value} onClick={handleSubmit}>
            Save
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export { UpdateIssuesStatusDialog };
